import type { Coding, Resource } from "@medplum/fhirtypes";
import { codeSystemUrl } from "@repo/fhir-systems";

/**
 * The discriminator shared by every catalog model that stores as a resource
 * type it does not own alone — today DiagnosticDefinition and
 * TreatmentDefinition, both ActivityDefinition.
 *
 * It lives in one module rather than one constant per mapper because a
 * discriminator only discriminates if both sides spell the system identically.
 * Two mappers that each declare their own system still reject each other's
 * rows, so nothing breaks loudly — but `kindOf` then reports the other kind as
 * *unmarked*, "every catalog definition" stops being one query, and the failure
 * only surfaces as a confusing error message. Sharing the declaration makes the
 * agreement structural instead of a convention two files have to keep.
 */
export const CATALOG_MODEL_KIND_SYSTEM = codeSystemUrl("catalog-model-kind");

export const PERFORMANCE_MEASURE_DEFINITION_KIND = "performance-measure-definition";
export const CONSENT_FORM_DEFINITION_KIND = "consent-form-definition";
export const DIAGNOSTIC_DEFINITION_KIND = "diagnostic-definition";
export const EXAM_DEFINITION_KIND = "exam-definition";
export const FINDING_DEFINITION_KIND = "finding-definition";
export const TREATMENT_DEFINITION_KIND = "treatment-definition";
export const PROTOCOL_DEFINITION_KIND = "protocol-definition";
export const PROGRAM_DEFINITION_KIND = "program-definition";
export const FLOW_DEFINITION_KIND = "flow-definition";

export function catalogModelKindTag(kind: string): Coding {
  return { system: CATALOG_MODEL_KIND_SYSTEM, code: kind };
}

/** The kind marker as read off a loaded resource; undefined for an unmarked row. */
export function catalogModelKindOf(resource: Resource): string | undefined {
  return resource.meta?.tag?.find((tag) => tag.system === CATALOG_MODEL_KIND_SYSTEM)?.code;
}
